<script>
    import { getContext, onMount } from 'svelte';
    import Form from '../../../../components/inputs/form';
    import TextInput from '../../../../components/inputs/text';
    import RichTextInput from '../../../../components/inputs/richtext';
    import SectionNav from '../../../../components/navigation/section';
    import Preview from '../../../../components/buttons/preview.card';
    import CommunicationTypeInput from '../../../../components/inputs/communication.type';
  
    const client = getContext('apollo');

    export let value;
    let program = value;
    export let id;
    export let index = 0;

  
    function changeEmail(i) {
      index = i;
    }

    const NAMES = {
      'Tips': 'Get Ready',
      'ThankYou': 'Thank You',
      'Reminder': 'Reminder'
    }

    const TIMES = {
      'Tips': 'Sent 7 days before the event',
      'ThankYou': 'Sent 2 days after the event',
      'Reminder': 'Sent 2 days before the event'
    }
  
  </script>
  
  
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-12">


        <div class="grid-x grid-margin-x">
          <div class="cell small-12 medium-9">
          {#each program.communications as communication, i}
            {#if index === i}
              <Form>
                <!--<Preview />-->
                <div class="help">
                    {TIMES[communication.type] ? TIMES[communication.type] : ''}
                </div>
                <div class="form-group">
                  <TextInput bind:value={communication.subject} placeholder="Subject" label="Subject" />
                </div>
                <div class="form-group">
                  <RichTextInput bind:value={communication.body} placeholder="Body" label="Body" />
                </div>
              </Form>
            {/if}
          {/each}
          </div>
          <div class="cell small-12 medium-3">
            <SectionNav hasSub="{true}">
                <ul>
                  {#each program.communications as communication, i}
                    <li class:active={i === index} on:click={() => changeEmail(i)}>
                      {NAMES[communication.type] ? NAMES[communication.type] : communication.type}
                    </li>
                  {/each}
                </ul>
              </SectionNav>
            </div>
        </div>
    </div>
  </div>
  